import React from 'react';
import {Button, Container} from 'react-bootstrap';

import SEO from '../SEO/SEO';

// Components that already exist in src/components/HomePage/
import ProductsSection from '../Products/ProductsSection';
import ArchitectureSection from '../Products/ArchitectureSection';
import DifferentiatorsSection from '../Products/DifferentiatorsSection';
import FAQSection from '../Products/FAQSection';
import CTASection from '../Common/CTASection';

import {useClarity} from '../hooks/useClarity';

const ProductsPage = () => {
    const {trackBookingClick} = useClarity();

    return (
        <>
            <SEO
                title="Nebulyx AI — Products & Platform"
                description="Nebulyx Cognition, AgentDOG and Nebulyx AI Studio. Trusted AI-driven answers across your business — consistent reasoning, layered decisioning, per-domain knowledge."
                canonicalUrl="https://nebulyx.ai/products"
            />

            <div className="products-page">

                {/* Slim hero — anchors the page, hands off into the stack below */}
                <section className="products-page-hero">
                    <Container className="text-center">
                        <div className="section-label" style={{color: 'rgba(255,255,255,0.75)'}}>
                            The Platform
                        </div>
                        <h1 className="products-page-hero-title">
                            Trusted AI-driven answers across your business.
                        </h1>
                        <p className="products-page-hero-subtitle">
                            Three products, one coherent stack.
                        </p>
                        <Button
                            size="lg"
                            className="cta-button-hero px-4 py-2 mt-3"
                            href="https://cal.eu/jon-cooke/discovery-call"
                            onClick={() => trackBookingClick('products-hero')}>
                            Book a Discovery Call
                        </Button>
                    </Container>
                </section>

                {/* 1. The three products at a glance */}
                <ProductsSection/>

                {/* 3. The architecture — how the three products fit together */}
                <ArchitectureSection/>


                {/* 8. Differentiators strip */}
                <DifferentiatorsSection/>

                {/* 10. Common questions */}
                <FAQSection/>

                {/* 11. Final CTA */}
                <CTASection/>
            </div>
        </>
    );
};

export default ProductsPage;